
import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { LinkDirective } from '../_shared/directives/link.directive';
import { IAuthor } from '../_shared/models/author.model';
import { IDynamicElement } from '../_shared/models/dynamic/dynamic-element.model';
import { ILink } from '../_shared/models/link.model';
import { MediaImage } from '../_shared/models/media/media-image.model';
import { AvatarComponent } from '../avatar/avatar.component';
import { ButtonComponent } from '../button/button.component';
import { HeadingComponent } from '../heading/heading.component';

import { TextHtmlComponent } from '../text-html/text-html.component';

@Component({
    selector: 'sirius-author',
    templateUrl: './author.component.html',
    styleUrls: ['./author.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
    LinkDirective,
    ButtonComponent,
    TranslateModule,
    AvatarComponent,
    HeadingComponent,
    TextHtmlComponent
],
    host: {
        role: 'article',
        itemscope: '',
        itemtype: 'https://schema.org/Person',
    }
})
export class AuthorComponent implements OnInit, IDynamicElement {
    @Input() name = '';
    @Input() descriptionHtml = '';
    @Input() jobTitle?: string;
    @Input() linkedInLink?: ILink;
    @Input() image?: MediaImage;
    @Input() config?: IAuthor;

    ngOnInit(): void {
        if (this.config) {
            this.name = this.config.name;
            this.jobTitle = this.config.jobTitle;
            this.descriptionHtml = this.config.descriptionHtml;
            this.linkedInLink = this.config.linkedInLink;
            this.image = this.config.image;
        }
    }
}
